import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';

// import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    FlexBLock,
    Tips,
    Input,
    LoadingBlock
} from '../../components';

import {
    Card
} from '../../components'

import useCopy from '../../hook/useCopy'

import {
    EtherToInt,
    ShortAddress
} from '../../ethers/e'

import {
    useEthers
} from '../../ethers/index'

import {
    useBalance
} from '../../context/balance'

import {
    useNodeData,
    useClaimCVC,
    useSwap
} from '../../hook/ma/useNode'

import {
    usePrice
} from '../../hook/ma/usePrice'

import useInput from '../../hook/useInput'


import {IconImg} from '../../components/Icon'

// import ChangeLanguage from '../Language'

function ShareLink() {
    const {account} = useEthers()
    const copy = useCopy()
    const invitLink = () => {
        // console.log()
        // copy(window.location.href+'?r=' + account)

        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (params.has('r')) {
            // 替换 r 的值
            params.set('r', account);
        } else {
            // 添加 r 参数
            params.append('r', account);
        }

        // 构建新的 URL
        const newUrl = `${url.origin}${url.pathname}?${params.toString()}${url.hash}`;
        copy(newUrl)
    }
    
    return <Button
        onClick={invitLink}
        size='small'
        type='b'
    >Copy Share Link</Button>
}

function ClaimButton({claimable}) {
    return <Button {...useClaimCVC()} disabled={!claimable}/>
}

// function RewardCVC() {
//     const node = useNodeData()        
//     return (
//         <FlexBLock>
//             <div>
//                 <TextM block>Rewarded CVC</TextM>
//                 <TextM color='2' block> <TextLinear style={{fontSize: '24px'}} >{EtherToInt(node.claimCVC)}</TextLinear> CVC</TextM>
//                 <TextS color='2'>Releaseable <TextS>{EtherToInt(node.totalReleaseableCVC)}</TextS> CVC</TextS>
//             </div>
//             <ClaimButton />
//         </FlexBLock>
//     )
// }


function MyBalances() {
    const {balances, prices, tokens, totalValue} = useBalance()
    const copy = useCopy()
    return (
        <>
            <TextM>Total Value</TextM>
            <TextM color='2' block>$ <TextLinear style={{fontSize: '24px'}} >{EtherToInt(totalValue)}</TextLinear></TextM>
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            {
                Object.keys(balances).map(name => {
                    const price = name === 'USDT' ? 1 : prices[name]
                    const balance = balances[name]
                    const value = price * balance
                    return (
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            key={name}
                            style={{
                                margin: '8px 0px'
                            }}
                        >
                            <div>
                                <TextM>
                                    {name}
                                    <TextM color='2' style={{marginLeft: '4px'}} onClick={() => copy(tokens[name][0])}>
                                        {ShortAddress(tokens[name][0])}
                                        <IconImg style={{marginLeft: '4px', width: '12px', height: 'auto', verticalAlign: 'inherit'}} src='./copy.png'/>
                                    </TextM>
                                    {
                                        name === 'CVC' &&
                                        <a
                                            href='https://bscscan.com/address/0xB45e6Dd851df10961D1aAD912BaF220168FCAA25#readContract'
                                            style={{
                                                textDecoration: 'none'
                                            }}
                                        >
                                            <TextS
                                                color='0'
                                                style={{
                                                    marginLeft: '4px',
                                                    padding: '1px 2px',
                                                    borderRadius: '2px',
                                                    background: 'rgb(74 166 33)'
                                                }}
                                            >
                                                Source
                                                <IconImg
                                                    style={{
                                                        marginLeft: '4px',
                                                        width: '10px',
                                                        height: 'auto',
                                                        verticalAlign: 'middle'
                                                    }}
                                                    src='./safe.png'
                                                />
                                            </TextS>
                                        </a>
                                    }
                                </TextM>
                                <TextS style={{display:'block'}} color='2'>{tokens[name][3]} <TextS color='0'>[${EtherToInt(price, price < 0.001 ? 10000000 : 1000)}]</TextS></TextS>
                            </div>
                            <div style={{textAlign:'right'}}>
                                <TextM>{EtherToInt(balance)}</TextM>
                                <TextS style={{display:'block'}} color='2'>$ {EtherToInt(value, value < 0.001 ? 1000000 : 1000)}</TextS>
                            </div>
                        </Stack>
                    )
                })
            }
        </>
    )
}

function Index() {    
    return (
        <Container>
            <FlexBLock>
                <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./wallet.png'/> My Wallet</TextMax>
                <ShareLink />
            </FlexBLock>
            <WhiteSpace />
            <Card style={{overflow:'unset'}} spacing={[0.6]}>
                {/* <RewardCVC />
                <WhiteSpace />
                <Hr />
                <WhiteSpace size={.4}/> */}
                <MyBalances />
            </Card>
            <WhiteSpace />
            <ReleaseList />
            <WhiteSpace />
            <SwapCVCD />
            <WhiteSpace />
            <LpCalculate />
             {/* <WhiteSpace />
                <Hr />
                <WhiteSpace/> */}
                
            {/* <Card style={{overflow:'unset'}}  spacing={[0.6]}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                >
                    <TextM>{t("Language")} (Language)</TextM>
                    <ChangeLanguage />
                </Stack>
            </Card> */}
        </Container>
    )
}

export default Index

function ReleaseList() {
    const node = useNodeData()
    return (
        <Card>
            <FlexBLock>
                <div>
                    <TextM block>Rewarded CVC <Tips type='a'>{node.releaseCycle} Weeks</Tips></TextM>
                    <TextM color='2' block> <TextLinear style={{fontSize: '24px'}} >{EtherToInt(node.claimCVC)}</TextLinear> CVC</TextM>
                </div>
                <ClaimButton claimable={node.cvcClaimable} />
            </FlexBLock>
            <FlexBLock>
                <TextS color='2'>Releaseable <TextS>{EtherToInt(node.totalReleaseableCVC)}</TextS> CVC</TextS>
                <TextS color='2'>Released <TextS>{EtherToInt(node.releasedCVC)}</TextS> CVC</TextS>
            </FlexBLock>
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <LoadingBlock loading={node.registed === null}>
                {
                    node.releaseList.map(v => (
                        <FlexBLock key={v.id}>
                            <TextS><TextLinear>{EtherToInt(v.balance)}</TextLinear> CVC</TextS>
                            <TextS><TextS color='2'>Start At.</TextS> {v.startAt}</TextS>
                        </FlexBLock>
                    ))
                }
            </LoadingBlock>
        </Card>
    )
}


function LpCalculate() {
    const {prices} = usePrice()
    const newUsdt = useInput('',{type: 'number'})
    return (
        <Card>
            <FlexBLock>
                <div
                    // style={{
                    //     textAlign: 'center'
                    // }}
                >
                    <TextM block>Treasury reserve CVC</TextM>
                    <TextLinear style={{fontSize: '24px'}} >{EtherToInt(prices.treasuryCVC)}</TextLinear>
                </div>
                <div
                    style={{
                        textAlign: 'right'
                    }}
                >
                    <TextM block>Total Burned CVC</TextM>
                    <TextLinear style={{fontSize: '24px'}} >{EtherToInt(prices.burnedCVC)}</TextLinear>
                </div>
            </FlexBLock>
            
            <WhiteSpace />
            <Hr />
            <WhiteSpace />
            <TextM>Lp Calculate</TextM>
            <TextS style={{marginBottom: '6px'}} block>Input USDT</TextS>
            <Input input={newUsdt} />
            <WhiteSpace />
            <FlexBLock>
                <TextM>CVC Expcet Price:</TextM>
                <TextM>{prices.ExpcetPrice(newUsdt.value)}</TextM>
            </FlexBLock>
        </Card>
    )
}

function SwapCVCD() {
    const {balances} = useBalance()
    const {
        button,
        amountInput
    } = useSwap()
    const disable = amountInput.value > balances.CVCD || balances.CVCD === '0' || amountInput.value === '' || isNaN(amountInput.value) || Number(amountInput.value) <= 0
    button.disabled = disable
    const max = () => {
        amountInput.onChange(balances.CVCD)
    }
    return (
        <Card>
            <TextM>Swap CVCD</TextM>
            <WhiteSpace />
            <TextS>Balance <TextLinear linear='2'>{EtherToInt(balances.CVCD)}</TextLinear> CVCD</TextS>
            <Input
                after={<Button size='small' type='d' onClick={max}>Max</Button>}
                input={amountInput}
            />
            <TextS color='2'>Expect <TextS>{EtherToInt(amountInput.value * 0.93)}</TextS> USDT</TextS>
            <WhiteSpace />
            {/* <Button type='b' style={{width: '100%'}} {...button} /> */}
            <Button type='b' disabled style={{width: '100%'}}>Updating</Button>
        </Card>
    )
}


// const PoolLogo = styled('img')`
//     width: 25px;
//     height: 25px;
//     display: inline-block;
//     vertical-align: sub;
//     margin-right: 4px;
// `



